import { Box, Divider, Typography } from "@mui/material";
import { useTranslations } from "hooks";
import { getTranslation } from "common";
import DraggableTaskCard from "./DraggableTaskCard";
import { Droppable } from "react-beautiful-dnd";
import { SequenceFlow, Task } from "model/activitiesModel";
import React from "react";
import noTaskDoing from "../image/img_doing.svg";
import { filterTasks } from "common/utilities";

interface DoingPanelProps {
  userId: number;
  all: boolean;
  filter: string;
  switchChecked: boolean;
  administrator?: boolean;
  dragItem: Task | null;
  tasks: Task[];
  handleSequenceFlowChoice: (task: Task, sequenceFlow: SequenceFlow) => void;
  goTodo: (task: Task) => Promise<void>;
  goToDone: (task: Task) => Promise<void>;
}

const DoingPanel: React.FC<DoingPanelProps> = ({
  handleSequenceFlowChoice,
  goToDone,
  goTodo,
  tasks,
  all,
  switchChecked,
  dragItem,
  administrator,
  filter
}) => {
  const translations = useTranslations();

  return (
    <Droppable isDropDisabled={dragItem?.state === 1} droppableId="doing">
      {(provided, snapshot) => (
        <Box
          // component={GlassCard}
          sx={{
            maxHeight: "90%",
            display: "flex",
            flexDirection: "column",
            borderRadius: "15px",
            pb: "10px",
            backgroundColor: (_) => _.palette.grey[200],
          }}
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          <Box>
            <Typography sx={{ flex: 1, textAlign: "start" }} variant="h6">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  ml: "10px",
                  mt: "8px",
                }}
              >
                <div
                  style={{
                    height: "10px",
                    width: "10px",
                    borderRadius: "50%",
                    backgroundColor: "#FFA500",
                    marginRight: "8px",
                  }}
                />
                {`${getTranslation(
                  translations,
                  "pm.label.process_status.doing"
                )} (${tasks.length})`}
              </Box>
            </Typography>
            <Divider
              sx={{
                height: "3px",
                borderRadius: "10px",
                backgroundColor: "#FFA500",
                mt: 3,
                mb: 3,
                width: "85%",
                mx: "auto",
              }}
            />
          </Box>

          <Box sx={{ height: "100%", overflow: "auto" }}>
            {tasks.length > 0 ? (
              tasks.filter(filterTasks(filter)).filter(_ => _.state === 1).map((task, index) => (
                <DraggableTaskCard
                  index={index}
                  key={task.idprocesstoken}
                  handleSequenceFlowChoice={handleSequenceFlowChoice}
                  all={all}
                  task={task}
                  switchChecked={switchChecked}
                  nextButtonLabel={getTranslation(
                    translations,
                    "pm.label.process_status.done"
                  )}
                  handleNextStep={goToDone}
                  handleBackStep={goTodo}
                  administrator={administrator}
                />
              ))
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                height="100%"
              >
                <Box
                  component="img"
                  alt="..."
                  sx={{
                    width: "208px",
                    height: "208px",
                  }}
                  src={noTaskDoing}
                />
                <Typography color="textSecondary" component="p" sx={{ mt: 1 }}>
                {getTranslation(translations, "generic.no_ongoing_activity.caption")}
                </Typography>
              </Box>
            )}
            {provided.placeholder}
          </Box>
        </Box>
      )}
    </Droppable>
  );
};

export default DoingPanel;
